<div class="container">
  @for (message of messages(); track message) {
    <div
      class="message {{ message.severity || '' }}"
      [class.clickable]="!!message.onClick"
      (click)="onMessageClick(message)"
      (mouseenter)="onMouseEnter(message)"
      (mouseleave)="onMouseLeave(message)"
      (focusin)="onFocusIn(message)"
      (focusout)="onFocusOut(message, $event)"
    >
      <div class="close-button-container">
        <button
          type="button"
          class="secondary"
          alg-button-icon
          icon="ph ph-x"
          (click)="onClose(message); $event.stopPropagation()"
        ></button>
      </div>
      <div class="message-icon-container">
        <i class="message-icon ph ph-check"></i>
      </div>
      <div class="message-body">
        @if (message.summary; as summary) {
          <div class="message-title">{{ summary }}</div>
        }
        <div class="message-text">{{ message.detail }}</div>
      </div>
    </div>
  }
</div>
